<template>
  <div
    class="modal-content"
    style="width: inherit; height: inherit; margin: 0 auto"
  >
    <div class="modal-header">
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 id="modal_title" class="modal-title">Add Transaction Adjustment</h4>
    </div>
    <div class="modal-body">
      <input id="trx_id" type="hidden" name="id" :value="transaction.id" />
      <input
        id="brain_tree_trx_id"
        type="hidden"
        name="brain_tree_trx_id"
        :value="transaction.brain_tree_transaction_id"
      />
      <TransactionInfo :transaction="transaction"></TransactionInfo>
      <hr />
      <div class="row px-4 pb-4">
        <div class="col-xs-12">
          <label for="type" class="control-label">Adjustment Type:</label>
          <select
            id="type"
            v-model="selectedType"
            class="form-control"
            name="type"
          >
            <option value="" disabled>
              Please select the type of adjustment...
            </option>
            <option
              v-for="adjustmentType in adjustmentTypes"
              :key="'adj-type-' + adjustmentType"
              :value="adjustmentType"
            >
              {{ adjustmentType | capitalize }}
            </option>
          </select>
        </div>
      </div>
      <hr v-if="selectedType" />
      <div v-if="selectedType" id="line-items-container" class="row px-4">
        <div class="col-xs-12">
          <h6>Select Items for this adjustment:</h6>
          <AdjustmentLineItem
            v-for="(item, index) in orderItemParts"
            :key="index"
            :self-index="index"
            :item="item"
            :adjustment-type="selectedType"
            @itemSelect="itemSelect"
            @itemTotalUpdated="itemTotalUpdated"
          />
        </div>

        <div class="col-12 text-right px-4">
          <p id="estimated-adjustment-total" class="hidden">{{ total }}</p>
          <h6>Estimated Total: {{ total | currency }}</h6>
        </div>
      </div>
      <hr v-if="itemsSelected && total !== 0" />
      <div v-if="itemsSelected && total !== 0" class="row px-4 pb-4">
        <div class="col-xs-12">
          <label for="adj_reason" class="control-label">Reason:</label>
          <select
            id="adj_reason"
            v-model="selectedReason"
            class="form-control"
            name="reason"
          >
            <option value="" disabled>
              Please select the reason for adjustment...
            </option>
            <option
              v-for="reason in availableReasons"
              :key="'adj-reason-' + reason"
              :value="reason"
            >
              {{ reason }}
            </option>
          </select>
        </div>
      </div>

      <div class="clearfix"></div>
    </div>
    <div class="modal-footer">
      <button
        :type="[selectedReason ? 'submit' : 'button']"
        :style="[selectedReason ? '' : 'pointer-events: none;']"
        :class="'btn btn-primary' + (selectedReason ? '' : ' disabled')"
      >
        Submit
      </button>
    </div>
  </div>
</template>

<script>
import AdjustmentLineItem from "./elements/AdjustmentLineItem.vue";
import TransactionInfo from "./elements/TransactionInfo.vue";

export default {
  components: {
    TransactionInfo,
    AdjustmentLineItem,
  },
  filters: {
    currency(amount) {
      return `$ ${amount.toFixed(2)}`;
    },
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
  props: {
    transaction: {
      type: Object,
      required: true,
    },
    orderItemParts: {
      type: Array,
      required: true,
    },
    adjustmentTypes: {
      type: Array,
      required: true,
    },
    adjustmentReasons: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedType: "",
      selectedReason: "",
      selectedItems: [],
      itemTotals: [],
    };
  },
  computed: {
    availableReasons() {
      return this.adjustmentReasons[this.selectedType];
    },
    itemsSelected() {
      return this.selectedItems.length > 0;
    },
    total() {
      return this.itemTotals.reduce((a, obj) => a + obj.total, 0);
    },
  },
  watch: {
    itemsSelected() {
      this.selectedReason = "";
    },
  },
  methods: {
    itemSelect(index, isSelected) {
      if (isSelected) {
        this.selectedItems.push(index);
      } else {
        this.selectedItems = this.selectedItems.filter((i) => i !== index);
      }
    },
    itemTotalUpdated(itemIndex, total) {
      const index = this.itemTotals.findIndex(
        (obj) => obj.itemIndex === itemIndex
      );
      if (index === -1) return this.itemTotals.push({ itemIndex, total });
      if (total === 0) return this.itemTotals.splice(itemIndex, 1);
      this.itemTotals[index].total = total;
      return this.itemTotals[index].total;
    },
  },
};
</script>
